import {
  Alert,
  Autocomplete,
  Button,
  CircularProgress,
  Grid2,
  IconButton,
  InputAdornment,
  Paper,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Box, Grid } from "@mui/system";
import SharedStateContext from "../../../../SharedStateProvider";
import EditMicroTargets from "./EditMicroTargets";
import EditMicroTarget from "./EditMicroTarget";
import { websiteTargetEndPointLogic } from "../../../../../logic/AssetManagement/WebsiteTarget/websiteTargetEndPointLogic";
import {
  setDisplayErrorSnackBar,
  setIsLoading,
} from "../../../../../features/userSlice";
import { NumericFormat } from "react-number-format";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import store from "../../../../../store";
// import { formatPercentage } from "../../../../../utils/helpers";

interface Props {
  oauthTokenHeader: any;
  response: any;
}

const EditTargetView = ({ oauthTokenHeader }: Props) => {
  const [selectedPeriod, setSelectedPeriod] = useState("") as any;
  const generatePeriodList = () => {
    const periods = [];
    const currentYear = new Date().getFullYear();

    // Generate future 4 years
    for (let year = currentYear; year <= currentYear + 10; year++) {
      for (let month = 0; month < 12; month++) {
        const formattedMonth = String(month + 1).padStart(2, "0"); // Format month as MM
        const formattedYear = String(year).slice(-2); // Get last two digits of the year
        periods.push({
          label: `${formattedMonth}/${formattedYear}`,
          value: `${year}-${formattedMonth}-01`,
        }); // Add value for "YYYY-MM-DD"
      }
    }

    // Generate past 2 years
    for (let year = currentYear - 2; year < currentYear; year++) {
      for (let month = 0; month < 12; month++) {
        const formattedMonth = String(month + 1).padStart(2, "0"); // Format month as MM
        const formattedYear = String(year).slice(-2); // Get last two digits of the year
        periods.push({
          label: `${formattedMonth}/${formattedYear}`,
          value: `${year}-${formattedMonth}-01`,
        }); // Add value for "YYYY-MM-DD"
      }
    }

    return periods;
  };

  // Get the period list and sort it in descending order
  const periodList = generatePeriodList().sort((a, b) => {
    const [monthA, yearA] = a.label.split("/").map(Number);
    const [monthB, yearB] = b.label.split("/").map(Number);
    return yearB - yearA || monthB - monthA;
  });
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [singleTargetContent, setSingleTargetContent] = useState([]) as any;
  const [, setWebsiteTargets] = useState([]) as any;
  const [microTargets, setMicroTargets] = useState([]) as any;
  const [, setMicroTargetsData] = useState([]) as any;
  const [ftd, setFtd] = useState("") as any;
  const [profit, setProfit] = useState("") as any;
  const [nrpu, setNrpu] = useState("") as any;
  const [spend, setSpend] = useState("") as any;
  const [clicks, setClicks] = useState("") as any;
  const [cvr, setCvr] = useState("") as any;
  const [cac, setCac] = useState(0) as any;
  const [cpa, setCpa] = useState("") as any;
  const [cpc, setCpc] = useState("") as any;
  const [rs, setRs] = useState("") as any;
  const [totalIncome, setTotalIncome] = useState("") as any;
  const [cpaPv, setCpaPv] = useState("") as any;
  const [rsPv, setRsPv] = useState("") as any;
  const [pv, setPv] = useState("") as any;
  const [netRevenue, setNetRevenue] = useState("") as any;
  const [avgRsDeal, setAvgRsDeal] = useState("") as any;
  const [epc, setEpc] = useState("") as any;
  const [epcCpa, setEpcCpa] = useState("") as any;
  const [epcRs, setEpcRs] = useState("") as any;
  const [growthTarget, setGrowthTarget] = useState("") as any;
  const [activeUsers, setActiveUsers] = useState("") as any;
  const [oldActiveUsers, setOldActiveUsers] = useState("") as any;
  const [acquiredActiveUsers, setAcquiredActiveUsers] = useState("") as any;
  const [charnRate, setCharnRate] = useState("") as any;
  const [acquiredToFtd, setAcquiredToFtd] = useState("") as any;
  const [avgNetRevToActiveUsers, setAvgNetRevToActiveUsers] = useState(
    ""
  ) as any;
  const [brToNgActiveRs, setBrToNgActiveRs] = useState("") as any;
  const location = useLocation();
  const [isValid, setIsValid] = useState(true);

  interface MicroTargetRef {
    getMicroTargetData: () => {
      geo?: any;
      product?: any;
      [key: string]: any;
    };
  }

  const microTargetRefs = useRef<React.RefObject<MicroTargetRef>[]>([]);

  useEffect(() => {
    microTargetRefs.current = microTargets.map(() =>
      React.createRef<MicroTargetRef>()
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddMicroTarget = () => {
    const newRef = React.createRef<MicroTargetRef>();
    setMicroTargets((prev: any) => [...prev, {}]);
    microTargetRefs.current = [...microTargetRefs.current, newRef];
  };

  const handleCollectMicroTargets = async () => {
    const mappedData = microTargetRefs.current.map((ref) => {
      const data = ref?.current?.getMicroTargetData();
      return data;
    });
    const validMicroTargets = mappedData
      .filter((data) => data?.geo && data?.product_type)
      .map((data: any) => ({
        ...data,
        cvr: Math.abs(parseFloat((data.cvr / 100).toFixed(4))) || 0, // Use data.cvr instead of cvr
      }));
    setMicroTargetsData(validMicroTargets);
    if (validMicroTargets.length === 0) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Please fill the mandatory fields to create micro targets",
          type: "error",
        })
      );
      return;
    }

    try {
      const apiCalls = validMicroTargets.map(
        (
          microTarget // Create an array of promises for each micro target API call
        ) =>
          websiteTargetEndPointLogic.createWebsiteMicroTarget(
            oauthTokenHeader,
            microTarget,
            selectedTargetSharedUid
          ) // Send individual micro target data
      );

      const responses = await Promise.all(apiCalls);
      const allSuccessful = responses.every((res) => res?.reason === "success");

      if (!allSuccessful) {
        const failedReasons = [
          ...new Set(
            responses
              .filter((res) => res?.reason !== "success")
              .map((res) => res?.reason)
          ),
        ];

        if (failedReasons.length > 0) {
          // Join all reasons into a single error message
          // throw new Error(failedReasons.join("  ") || "One or more micro targets failed to add.");
          setSnackbarOpen(true);
          setSnackbarMessage(
            `${
              failedReasons.join("  ") ||
              "One or more micro targets failed to add."
            }`
          );
          setIsValid(false);
          return;
        }
      }

      handleCancelClick();
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Website Micro Target Added Successfully",
          type: "success",
        })
      );
    } catch (error: any) {
      const errorMessage =
        typeof error === "string"
          ? error
          : error instanceof Error
          ? error.message
          : "An unexpected error occurred.";

      //dispatch(setDisplayErrorSnackBar({ message: errorMessage, type: "error" }));
      setSnackbarOpen(true);
      setSnackbarMessage(`${errorMessage}`);
      setIsValid(false);
      return;
    }
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { handleCreateClose } = useContext(SharedStateContext);
  const [searchParams] = useSearchParams();
  const selectedSite = searchParams.get("selectedSite") as any;
  const selectedTargetSharedUid = searchParams.get(
    "websiteTargetSharedUid"
  ) as any;
  const handleCancelClick = () => {
    handleCreateClose();
    const newSearchParams = new URLSearchParams(location.search);
    newSearchParams.delete("websiteTargetSharedUid");
    newSearchParams.set("page", "0"); // Set page to 0 when redirecting
    navigate(
      `/business_leader/website_projection?${newSearchParams.toString()}`
    );
  };

  const [expanded, setExpanded] = useState<string | false>(false);

  useEffect(() => {
    const newSearchParams = new URLSearchParams(location.search);
    // Check if we're on the website_projection page and set page to 0 if needed
    if (
      location.pathname === "/business_leader/website_projection" &&
      newSearchParams.get("page") !== "0"
    ) {
      newSearchParams.set("page", "0");
      navigate(`${location.pathname}?${newSearchParams.toString()}`, {
        replace: true,
      });
    }
  }, [location.search, location.pathname, navigate]);

  const handleChange = (panel: string) => (_: unknown, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    const fetchSingleWebsiteTarget = async () => {
      setLoading(true);
      try {
        if (
          selectedTargetSharedUid !== null &&
          selectedTargetSharedUid !== ""
        ) {
          await websiteTargetEndPointLogic.getSingleWebsiteTarget(
            oauthTokenHeader,
            selectedSite,
            selectedTargetSharedUid,
            setSingleTargetContent
          );
        } else {
          throw new Error("Unauthorized access for targets");
        }
      } catch (error: any) {
        store.dispatch(
          setDisplayErrorSnackBar({
            message: error?.parsedText || "Error while fetching data.",
            type: "error",
          })
        );
      } finally {
        setLoading(false);
      }
    };
    if (selectedTargetSharedUid !== null && selectedTargetSharedUid !== "") {
      fetchSingleWebsiteTarget();
    }
  }, [oauthTokenHeader, selectedSite, selectedTargetSharedUid]);

  useEffect(() => {
    if (singleTargetContent) {
      setSelectedPeriod(singleTargetContent?.[0]?.month); // Set the formatted month as the selected period
      setFtd(singleTargetContent?.[0]?.ftd);
      setProfit(singleTargetContent?.[0]?.profit);
      setNrpu(singleTargetContent?.[0]?.nrpu);
      setSpend(singleTargetContent?.[0]?.spend);
      setClicks(singleTargetContent?.[0]?.clicks);
      setCvr(singleTargetContent?.[0]?.cvr * 100);
      setCac(singleTargetContent?.[0]?.cac);
      setCpa(singleTargetContent?.[0]?.cpa);
      setCpc(singleTargetContent?.[0]?.cpc);
      setRs(singleTargetContent?.[0]?.rs);
      setTotalIncome(singleTargetContent?.[0]?.total_income);
      setCpaPv(singleTargetContent?.[0]?.cpa_pv);
      setRsPv(singleTargetContent?.[0]?.rs_pv);
      setPv(singleTargetContent?.[0]?.pv);
      setNetRevenue(singleTargetContent?.[0]?.net_revenue);
      setAvgRsDeal(singleTargetContent?.[0]?.avg_rs_deal_p * 100);
      setEpc(singleTargetContent?.[0]?.epc);
      setEpcCpa(singleTargetContent?.[0]?.epc_cpa);
      setEpcRs(singleTargetContent?.[0]?.epc_rs);
      setGrowthTarget(singleTargetContent?.[0]?.growth_target * 100);
      setActiveUsers(
        singleTargetContent?.[0]?.active_users &&
          Math.floor(Number(singleTargetContent?.[0]?.active_users))
      );
      setOldActiveUsers(
        singleTargetContent?.[0]?.old_active_users &&
          Math.floor(Number(singleTargetContent?.[0]?.old_active_users))
      );
      setAcquiredActiveUsers(
        singleTargetContent?.[0]?.acquired_active_users &&
          Math.floor(Number(singleTargetContent?.[0]?.acquired_active_users))
      );
      setCharnRate(singleTargetContent?.[0]?.churn_rate * 100);
      setAcquiredToFtd(
        singleTargetContent?.[0]?.ratio_between_acquired_to_ftd * 100
      );
      setAvgNetRevToActiveUsers(
        singleTargetContent?.[0]?.avg_net_rev_per_active_user &&
          Math.floor(
            Number(singleTargetContent?.[0]?.avg_net_rev_per_active_user)
          )
      );
      setBrToNgActiveRs(
        singleTargetContent?.[0]?.br_to_ng_active_rs_ratio * 100
      );
    }
  }, [singleTargetContent]);

  const [Geos, setGeos] = useState([]) as any;
  const [Products, setProducts] = useState([]) as any;
  const websiteMicroTarget = useSelector(
    (state: any) => state.websiteTarget.microTargetList
  );

  useEffect(() => {
    const fetchGeos = async () => {
      setIsLoading(true);
      try {
        await websiteTargetEndPointLogic.getGeo(oauthTokenHeader, setGeos);
      } catch (error: any) {
        store.dispatch(
          setDisplayErrorSnackBar({
            message: error?.parsedText || "Error while fetching data.",
            type: "error",
          })
        );
      } finally {
        setIsLoading(false);
      }
    };
    if (oauthTokenHeader) {
      fetchGeos();
    }
  }, [oauthTokenHeader]);

  useEffect(() => {
    const fetchProductType = async () => {
      setIsLoading(true);
      try {
        await websiteTargetEndPointLogic.getProductType(
          oauthTokenHeader,
          setProducts
        );
      } catch (error: any) {
        store.dispatch(
          setDisplayErrorSnackBar({
            message: error?.parsedText || "Error while fetching data.",
            type: "error",
          })
        );
      } finally {
        setIsLoading(false);
      }
    };
    if (oauthTokenHeader) {
      fetchProductType();
    }
  }, [oauthTokenHeader]);

  useEffect(() => {
    const fetchMicroTargets = async () => {
      setIsLoading(true);
      setLoading(true);
      try {
        await websiteTargetEndPointLogic.getWebsiteMicroTargets(
          oauthTokenHeader,
          selectedSite,
          dispatch
        );
      } catch (error: any) {
        store.dispatch(
          setDisplayErrorSnackBar({
            message: error?.parsedText || "Error while fetching data.",
            type: "error",
          })
        );
      } finally {
        setIsLoading(false);
        setLoading(false);
      }
    };
    if (oauthTokenHeader) {
      fetchMicroTargets();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oauthTokenHeader, selectedSite]);

  const GeoList = Geos.map((geo: any) => {
    return { name: geo.name, uid: geo.shared_uid };
  });

  const ProductTypes = Products.map((product: any) => {
    return { name: product.type_name, uid: product.shared_uid };
  });

  const [microTargetPayload, setMicroTargetPayload] = useState({}) as any;
  const handleMicroTargetChange = (
    index: number,
    field: string,
    value: any
  ) => {
    setMicroTargetPayload((prev: any) => {
      const updatedPayload = {
        ...prev,
        [index]: {
          ...prev[index],
          [field]: value,
        },
      };
      return updatedPayload;
    });
  };

  useEffect(() => {
    if (websiteMicroTarget && websiteMicroTarget.length > 0) {
      const filteredTargets = websiteMicroTarget.filter(
        (target: any) =>
          target.website_target_shared_uid === selectedTargetSharedUid
      );
      const initialPayload = filteredTargets.reduce(
        (acc: any, target: any, index: number) => {
          acc[index] = {
            ...target,
            website_target_shared_uid: selectedTargetSharedUid,
          };
          return acc;
        },
        {}
      );

      const newMicroData = { ...initialPayload };
      for (const key in newMicroData) {
        if (newMicroData[key].cvr !== undefined) {
          newMicroData[key].cvr = newMicroData[key].cvr * 100;
        }
      }
      setMicroTargetPayload((prev: any) =>
        Object.keys(prev).length === 0 ? newMicroData : prev
      );
    }
  }, [websiteMicroTarget, selectedTargetSharedUid]);

  const handleRemoveMicroTarget = (index: any) => {
    const newMicroTargets = microTargets.filter(
      (_: any, i: any) => i !== index
    ); // Remove the micro target at the specified index
    setMicroTargets(newMicroTargets);
  };

  const editMicroTargets = async () => {
    const microTargets = Object.values(microTargetPayload);
    try {
      setLoading(true);
      const updatedMicroTargets = microTargets.map((target: any) => {
        const data = {
          geo: (target as any).geo,
          product_type: (target as any).product_type,
          spend:
            Math.abs(
              parseFloat(String((target as any).spend).replace(/,/g, ""))
            ) || 0,
          ftd:
            Math.abs(
              parseFloat(String((target as any).ftd).replace(/,/g, ""))
            ) || 0,
          profit:
            Math.abs(
              parseFloat(String((target as any).profit).replace(/,/g, ""))
            ) || 0,
          nrpu:
            Math.abs(
              parseFloat(String((target as any).nrpu).replace(/,/g, ""))
            ) || 0,
          rs:
            Math.abs(
              parseFloat(String((target as any).rs).replace(/,/g, ""))
            ) || 0,
          cpa:
            Math.abs(
              parseFloat(String((target as any).cpa).replace(/,/g, ""))
            ) || 0,
          total_income:
            Math.abs(
              parseFloat(String((target as any).total_income).replace(/,/g, ""))
            ) || 0,
          clicks:
            Math.abs(
              parseFloat(String((target as any).clicks).replace(/,/g, ""))
            ) || 0,
          cvr:
            Math.abs(
              parseFloat(String((target as any).cvr).replace(/,/g, ""))
            ) / 100 || 0,
          cac:
            Math.abs(
              parseFloat(String((target as any).cac).replace(/,/g, ""))
            ) || 0,
          cpa_pv:
            Math.abs(
              parseFloat(String((target as any).cpa_pv).replace(/,/g, ""))
            ) || 0,
          rs_pv:
            Math.abs(
              parseFloat(String((target as any).rs_pv).replace(/,/g, ""))
            ) || 0,
          pv:
            Math.abs(
              parseFloat(String((target as any).pv).replace(/,/g, ""))
            ) || 0,
        };
        return websiteTargetEndPointLogic.updateWebsiteMicroTarget(
          oauthTokenHeader,
          data,
          (target as any).shared_uid
        );
      });

      const responses = await Promise.all(updatedMicroTargets);
      const allSuccessful = responses.every(
        (res: any) => res?.reason === "success"
      );

      if (!allSuccessful) {
        const failedReasons = [
          ...new Set(
            responses
              .filter((res: any) => res?.reason !== "success")
              .map((res: any) => res?.reason)
          ),
        ];

        if (failedReasons.length > 0) {
          // Join all reasons into a single error message
          // throw new Error(failedReasons.join("  ") || "Failed to update micro tasks.");
          setSnackbarOpen(true);
          setSnackbarMessage(
            `${failedReasons.join("  ") || "Failed to update micro tasks."}`
          );
          setIsValid(false);
          return;
        }
      }
      handleCancelClick();
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Website target and micro targets updated successfully",
          type: "success",
        })
      );
    } catch (error: any) {
      const errorMessage =
        typeof error === "string"
          ? error
          : error instanceof Error
          ? error.message
          : "An unexpected error occurred.";
      //dispatch(setDisplayErrorSnackBar({ message: errorMessage, type: "error" }));
      setSnackbarOpen(true);
      setSnackbarMessage(`${errorMessage}`);
      setIsValid(false);
      return;
    } finally {
      setLoading(false);
    }
  };

  const updateWebsitetarget = async () => {
    const data = {
      month: selectedPeriod,
      spend: Math.abs(parseFloat(spend)) || 0,
      clicks: Math.abs(parseFloat(clicks)) || 0,
      ftd: Math.abs(parseFloat(ftd)) || 0,
      cvr: Math.abs(parseFloat((parseFloat(cvr) / 100).toFixed(4))) || 0,
      cac: Math.abs(parseFloat(cac)) || 0,
      profit: Math.abs(parseFloat(profit)) || 0,
      cpc: Math.abs(parseFloat(cpc)) || 0,
      nrpu: Math.abs(parseFloat(nrpu)) || 0,
      cpa: Math.abs(parseFloat(cpa)) || 0,
      rs: Math.abs(parseFloat(rs)) || 0,
      total_income: Math.abs(parseFloat(totalIncome)) || 0,
      cpa_pv: Math.abs(parseFloat(cpaPv)) || 0,
      rs_pv: Math.abs(parseFloat(rsPv)) || 0,
      pv: Math.abs(parseFloat(pv)) || 0,
      growth_target: Number((parseFloat(growthTarget) / 100).toFixed(4)) || 0,
      active_users: Math.abs(parseInt(activeUsers)) || 0,
      old_active_users: Math.abs(parseInt(oldActiveUsers)) || 0,
      acquired_active_users: Math.abs(parseInt(acquiredActiveUsers)) || 0,
      churn_rate:
        Math.abs(parseFloat((parseFloat(charnRate) / 100).toFixed(4))) || 0,
      ratio_between_acquired_to_ftd:
        Math.abs(parseFloat((parseFloat(acquiredToFtd) / 100).toFixed(4))) || 0,
      avg_net_rev_per_active_user:
        Math.abs(parseFloat(avgNetRevToActiveUsers)) || 0.0,
      net_revenue: Math.abs(parseFloat(netRevenue)) || 0,
      avg_rs_deal_p:
        Math.abs(parseFloat((parseFloat(avgRsDeal) / 100).toFixed(4))) || 0,
      br_to_ng_active_rs_ratio:
        Math.abs(parseFloat((parseFloat(brToNgActiveRs) / 100).toFixed(4))) ||
        0,
      epc_cpa: Math.abs(parseFloat(epcCpa)) || 0,
      epc_rs: Math.abs(parseFloat(epcRs)) || 0,
      epc: Math.abs(parseFloat(epc)) || 0,
    };
    // setLoading(true);
    try {
      let response;
      if (selectedSite) {
        response = await websiteTargetEndPointLogic.updateWebsiteTarget(
          oauthTokenHeader,
          data,
          selectedTargetSharedUid
        );
      } else {
        throw new Error("User doesn't have permissions to create new target");
      }
      // setIsLoading(true);
      // setLoading(true);
      await websiteTargetEndPointLogic.getAllWebsiteTarget(
        oauthTokenHeader,
        selectedSite,
        setWebsiteTargets
      );
      return response;
    } catch (error: any) {
      // store.dispatch(setDisplayErrorSnackBar({ message: error?.parsedText || 'Error while fetching data.', type: 'error' }));
      setSnackbarOpen(true);
      setSnackbarMessage(
        `${error?.parsedText || "Error while fetching data."}`
      );
      setIsValid(false);
      return;
      //return null;
    } finally {
      setLoading(false);
    }
  };

  const validate = async () => {
    if (selectedPeriod === "") {
      setSnackbarOpen(true);
      setSnackbarMessage("Please select a period");
      setIsValid(false);
      return false;
    }

    const mandatoryFields = [
      { name: "Spend", value: spend },
      { name: "FTD", value: ftd },
      { name: "Profit", value: profit },
      { name: "NRPU", value: nrpu },
      { name: "RS", value: rs },
      { name: "Clicks", value: clicks },
      { name: "CPC", value: cpc },
      { name: "CAC", value: cac },
      { name: "Total Income", value: totalIncome },
      { name: "Active Users", value: activeUsers },
    ];

    const emptyFields = mandatoryFields
      .filter((field) => !field.value)
      .map((field) => field.name);

    if (emptyFields.length > 0) {
      setSnackbarOpen(true);
      setSnackbarMessage(
        `Please fill the mandatory fields: ${emptyFields.join(", ")}`
      );
      setIsValid(false);
      return false;
    }

    setIsValid(true);
    return true;
  };

  const handleUpdateTarget = async () => {
    const isFormValid = await validate();
    if (!isFormValid) return;
    try {
      setLoading(true);
      const websiteTargetResponse = await updateWebsitetarget();
      // Only proceed with micro targets update if the website target update was successful
      if (websiteTargetResponse && websiteTargetResponse.status === 200) {
        if (
          !microTargetPayload ||
          Object.keys(microTargetPayload).length === 0
        ) {
          setLoading(true);
          handleCancelClick();
          store.dispatch(
            setDisplayErrorSnackBar({
              message: "Website target updated successfully",
              type: "success",
            })
          );
          return; // Stop further execution
        } else {
          await editMicroTargets();
          setLoading(true);
        }
      }
    } catch (error: any) {
      // store.dispatch(
      //   setDisplayErrorSnackBar({
      //     message: error?.parsedText || "Error while fetching data.",
      //     type: "error",
      //   })
      // );
      setSnackbarOpen(true);
      setSnackbarMessage(
        `${error?.parsedText || "Error while fetching data."}`
      );
      setIsValid(false);
      return;
    } finally {
      setIsLoading(false);
      setLoading(false);
    }
  };

  const renderSnackbar = () => {
    return (
      <Snackbar
        sx={{ zIndex: "9999999" }}
        open={snackbarOpen}
        autoHideDuration={5500}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert
          elevation={6}
          //variant="filled"
          onClose={() => setSnackbarOpen(false)}
          severity={
            snackbarMessage.includes("Error") || isValid ? "success" : "error"
          }
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    );
  };

  return (
    <>
      {renderSnackbar()}
      <Paper>
        <Box sx={{ padding: "16px !important" }}>
          <Typography fontSize={24} mb={2}>
            Edit Projection
          </Typography>
          <Grid2
            container
            mt={1}
            columnSpacing={3}
            mb={1}
            justifyContent={"space-between"}
          >
            <Grid2 size={4}>
              <Autocomplete
                sx={{ width: "100%" }}
                options={periodList}
                getOptionLabel={(option: any) => option.label}
                value={
                  periodList.find(
                    (option) => option.value === selectedPeriod
                  ) || null
                }
                disabled
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Month & Year"
                    label="Period"
                    required
                    InputProps={{
                      ...params.InputProps,
                    }}
                    color="secondary"
                  />
                )}
                size="small"
              />
            </Grid2>
            <Grid2 size={5}>
              <Stack flexDirection={"row"} justifyContent={"end"} gap={1}>
                <Button color="secondary" variant="text">
                  <Stack onClick={handleCancelClick}>Cancel</Stack>
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  onClick={handleAddMicroTarget}
                >
                  <Stack flexDirection={"row"} alignItems={"center"} gap={1}>
                    Add micro projection <AddIcon fontSize="small" />
                  </Stack>
                </Button>
                <Button
                  variant="contained"
                  onClick={handleUpdateTarget}
                  data-tracker="94"
                  color="secondary"
                  sx={{ textTransform: "uppercase" }}
                  disabled={
                    microTargets.length > 0 &&
                    microTargets.every(
                      (target: any) => Object.keys(target).length === 0
                    )
                  }
                >
                  <Stack flexDirection={"row"} gap={1}>
                    {loading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      "Update projection"
                    )}
                    <CheckIcon fontSize="small" />
                  </Stack>
                </Button>
              </Stack>
            </Grid2>
          </Grid2>
        </Box>
        {/* <EditTargetList/> */}
        <Grid2 container columnSpacing={0}>
          <Grid2 size={12}>
            <Accordion
              expanded={expanded === "panel1"}
              onChange={handleChange("panel1")}
              className="setTargetList"
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon color="secondary" />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography
                  component="span"
                  sx={{ width: "33%", flexShrink: 0 }}
                >
                  Key metrics
                </Typography>
                <Typography component="span" sx={{ color: "text.secondary" }}>
                  Contains Mandatory Fields
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid2 container mt={2} columnSpacing={3}>
                  <Grid2 size={4}>
                    <NumericFormat
                      customInput={TextField}
                      label="FTD"
                      variant="outlined"
                      fullWidth
                      required
                      color="secondary"
                      size="small"
                      value={ftd}
                      onValueChange={(values) => setFtd(values.value)}
                      thousandSeparator=","
                      sx={{ width: "100%" }}
                    />
                  </Grid2>
                  <Grid2 size={4}>
                    <NumericFormat
                      customInput={TextField}
                      label="Profit"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      required
                      value={profit}
                      onValueChange={(values) => setProfit(values.value)}
                      thousandSeparator=","
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4}>
                    <NumericFormat
                      customInput={TextField}
                      label="NRPU"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      required
                      value={nrpu}
                      onValueChange={(values) => setNrpu(values.value)}
                      thousandSeparator=","
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="Spend"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      required
                      value={spend}
                      onValueChange={(values) => setSpend(values.value)}
                      thousandSeparator=","
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="Clicks"
                      variant="outlined"
                      fullWidth
                      required
                      color="secondary"
                      size="small"
                      value={clicks}
                      onValueChange={(values) => setClicks(values.value)}
                      thousandSeparator=","
                      sx={{ width: "100%" }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="CVR"
                      placeholder="In Percentage"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={cvr}
                      onValueChange={(values) => setCvr(values.value)}
                      isAllowed={(values) => {
                        const { formattedValue } = values;
                        // Allow digits, commas, and one decimal point
                        return /^[\d,]*\.?\d*$/.test(
                          formattedValue.replace(/,/g, "")
                        );
                      }}
                      thousandSeparator=","
                      decimalScale={2} // optional: limits to 2 decimal places
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="CAC"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      required
                      color="secondary"
                      size="small"
                      value={cac}
                      onValueChange={(values) => setCac(values.value)}
                      thousandSeparator=","
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="CPC"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      required
                      color="secondary"
                      size="small"
                      value={cpc}
                      onValueChange={(values) => setCpc(values.value)}
                      thousandSeparator=","
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={12}>
                    <Typography
                      fontSize={14}
                      mt={1}
                      sx={{ color: "#00000099" }}
                    >
                      Fields marked with * are mandatory.
                    </Typography>
                  </Grid2>
                </Grid2>
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expanded === "panel2"}
              onChange={handleChange("panel2")}
              className="AddMicroTargetWrap"
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon color="secondary" />}
                aria-controls="panel2bh-content"
                id="panel2bh-header"
              >
                <Typography
                  component="span"
                  sx={{ width: "33%", flexShrink: 0 }}
                >
                  Income
                </Typography>
                <Typography component="span" sx={{ color: "text.secondary" }}>
                  Contains Mandatory Fields
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid2 container mt={2} columnSpacing={3}>
                  <Grid2 size={4}>
                    <NumericFormat
                      customInput={TextField}
                      label="CPA"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={cpa}
                      onValueChange={(values) => setCpa(values.value)}
                      thousandSeparator=","
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4}>
                    <NumericFormat
                      customInput={TextField}
                      label="RS"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      required
                      color="secondary"
                      size="small"
                      value={rs}
                      onValueChange={(values) => setRs(values.value)}
                      thousandSeparator=","
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4}>
                    <NumericFormat
                      customInput={TextField}
                      label="Total Income"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      required
                      color="secondary"
                      size="small"
                      value={totalIncome}
                      onValueChange={(values) => setTotalIncome(values.value)}
                      thousandSeparator=","
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="CPA PV"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={cpaPv}
                      onValueChange={(values) => setCpaPv(values.value)}
                      thousandSeparator=","
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="RS PV"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={rsPv}
                      onValueChange={(values) => setRsPv(values.value)}
                      thousandSeparator=","
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="PV"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={pv}
                      onValueChange={(values) => setPv(values.value)}
                      thousandSeparator=","
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="Net Revenue"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={netRevenue}
                      onValueChange={(values) => setNetRevenue(values.value)}
                      thousandSeparator=","
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="Avg RS Deal"
                      placeholder="In Percentage"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={avgRsDeal}
                      onValueChange={(values) => setAvgRsDeal(values.value)}
                      isAllowed={(values) => {
                        const { formattedValue } = values;
                        // Allow digits, commas, and one decimal point
                        return /^[\d,]*\.?\d*$/.test(
                          formattedValue.replace(/,/g, "")
                        );
                      }}
                      thousandSeparator=","
                      decimalScale={2} // optional: limits to 2 decimal places
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="EPC"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={epc}
                      onValueChange={(values) => setEpc(values.value)}
                      thousandSeparator=","
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="EPC CPA"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={epcCpa}
                      onValueChange={(values) => setEpcCpa(values.value)}
                      thousandSeparator=","
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="EPC RS"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={epcRs}
                      onValueChange={(values) => setEpcRs(values.value)}
                      thousandSeparator=","
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={12}>
                    <Typography
                      fontSize={14}
                      mt={1}
                      sx={{ color: "#00000099" }}
                    >
                      Fields marked with * are mandatory.
                    </Typography>
                  </Grid2>
                </Grid2>
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expanded === "panel3"}
              onChange={handleChange("panel3")}
              className="AddMicroTargetWrap"
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon color="secondary" />}
                aria-controls="panel3bh-content"
                id="panel3bh-header"
              >
                <Typography
                  component="span"
                  sx={{ width: "33%", flexShrink: 0 }}
                >
                  Performance
                </Typography>
                <Typography component="span" sx={{ color: "text.secondary" }}>
                  Contains Mandatory Fields
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid2 container mt={2} columnSpacing={3}>
                  <Grid2 size={4}>
                    <NumericFormat
                      customInput={TextField}
                      label="Growth Target"
                      placeholder="In Percentage"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={growthTarget}
                      onValueChange={(values) => setGrowthTarget(values.value)}
                      isAllowed={(values) => {
                        const { formattedValue } = values;
                        // Allow digits, commas, optional one decimal, and leading minus
                        const cleanValue = formattedValue.replace(/,/g, "");
                        return /^-?\d*\.?\d*$/.test(cleanValue);
                      }}
                      thousandSeparator=","
                      decimalScale={2} // optional: limits to 2 decimal places
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4}>
                    <NumericFormat
                      customInput={TextField}
                      label="Active Users"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={activeUsers}
                      onValueChange={(values) => setActiveUsers(values.value)}
                      isAllowed={(values) => {
                        const { formattedValue } = values;
                        // Allow only digits and commas (block ., -, ), etc.)
                        return /^[\d,]*$/.test(formattedValue);
                      }}
                      thousandSeparator=","
                      sx={{ width: "100%" }}
                    />
                  </Grid2>
                  <Grid2 size={4}>
                    <NumericFormat
                      customInput={TextField}
                      label="Old Active Users"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={oldActiveUsers}
                      onValueChange={(values) =>
                        setOldActiveUsers(values.value)
                      }
                      isAllowed={(values) => {
                        const { formattedValue } = values;
                        // Allow only digits and commas (block ., -, ), etc.)
                        return /^[\d,]*$/.test(formattedValue);
                      }}
                      thousandSeparator=","
                      sx={{ width: "100%" }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="Acquired Active Users"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={acquiredActiveUsers}
                      onValueChange={(values) =>
                        setAcquiredActiveUsers(values.value)
                      }
                      isAllowed={(values) => {
                        const { formattedValue } = values;
                        // Allow only digits and commas (block ., -, ), etc.)
                        return /^[\d,]*$/.test(formattedValue);
                      }}
                      thousandSeparator=","
                      sx={{ width: "100%" }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="Churn Rate"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={charnRate}
                      onValueChange={(values) => setCharnRate(values.value)}
                      isAllowed={(values) => {
                        const { formattedValue } = values;
                        // Allow digits, commas, and one decimal point
                        return /^[\d,]*\.?\d*$/.test(
                          formattedValue.replace(/,/g, "")
                        );
                      }}
                      thousandSeparator=","
                      decimalScale={2} // optional: limits to 2 decimal places
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="Acquired to FTD"
                      placeholder="In Percentage"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={acquiredToFtd}
                      onValueChange={(values) => setAcquiredToFtd(values.value)}
                      isAllowed={(values) => {
                        const { formattedValue } = values;
                        // Allow digits, commas, and one decimal point
                        return /^[\d,]*\.?\d*$/.test(
                          formattedValue.replace(/,/g, "")
                        );
                      }}
                      thousandSeparator=","
                      decimalScale={2} // optional: limits to 2 decimal places
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="Avg Net Rev To Active Users"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      required
                      color="secondary"
                      size="small"
                      value={avgNetRevToActiveUsers}
                      onValueChange={(values) =>
                        setAvgNetRevToActiveUsers(values.value)
                      }
                      thousandSeparator=","
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="BR to Ng Active RS"
                      placeholder="In Percentage"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={brToNgActiveRs}
                      onValueChange={(values) =>
                        setBrToNgActiveRs(values.value)
                      }
                      isAllowed={(values) => {
                        const { formattedValue } = values;
                        // Allow digits, commas, and one decimal point
                        return /^[\d,]*\.?\d*$/.test(
                          formattedValue.replace(/,/g, "")
                        );
                      }}
                      thousandSeparator=","
                      decimalScale={2} // optional: limits to 2 decimal places
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                </Grid2>
              </AccordionDetails>
            </Accordion>
          </Grid2>
        </Grid2>
        <Box sx={{ pt: 2, px: 2 }}>
          <Grid2 size={12}>
            {loading ? (
              <Grid container justifyContent="center" mt={2}>
                <CircularProgress color="secondary" />
              </Grid>
            ) : (
              <EditMicroTargets
                websiteMicroTarget={websiteMicroTarget.filter(
                  (microTarget: any) =>
                    microTarget.website_target_shared_uid ===
                    selectedTargetSharedUid
                )}
                selectedTargetSharedUid={selectedTargetSharedUid}
                GeoList={GeoList}
                ProductTypes={ProductTypes}
                onMicroTargetChange={handleMicroTargetChange}
                microTargetPayload={microTargetPayload}
              />
            )}
          </Grid2>
        </Box>
        <Box>
          {microTargets.map((_: any, index: number) => {
            // Calculate the index by adding the number of existing micro targets
            const existingMicroTargetsCount = websiteMicroTarget.filter(
              (microTarget: any) =>
                microTarget.website_target_shared_uid ===
                selectedTargetSharedUid
            ).length;
            const adjustedIndex = existingMicroTargetsCount + index;

            return (
              <Box
                key={index}
                sx={{ display: "flex", alignItems: "flex-start", pt: 2, px: 2 }}
              >
                <EditMicroTarget
                  ref={microTargetRefs.current[index]}
                  oauthTokenHeader={oauthTokenHeader}
                  selectedTargetSharedUid={selectedTargetSharedUid}
                  index={adjustedIndex}
                />
                <IconButton
                  size="small"
                  onClick={() => handleRemoveMicroTarget(index)}
                  sx={{ mt: 1 }}
                >
                  <CloseIcon color="secondary" />
                </IconButton>
              </Box>
            );
          })}
          {microTargets.length > 0 && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 2,
                pb: 2,
                px: 2,
              }}
            >
              <Button
                variant="contained"
                color="secondary"
                size="medium"
                startIcon={<AddIcon />}
                onClick={handleCollectMicroTargets}
              >
                Add All Micro Targets
              </Button>
            </Box>
          )}
        </Box>
      </Paper>
    </>
  );
};

export default EditTargetView;
